import Button from 'components/Button/Button';
import { cn } from 'components/lib/utils';

import { OfferTypeCardConfig } from '../../types';

interface OfferTypeCardProps {
  config: OfferTypeCardConfig;
  onClick: (config: OfferTypeCardConfig) => void;
}

export const OfferTypeCard = ({ config, onClick }: OfferTypeCardProps) => {
  const { title, description, image, disabled } = config;

  return (
    <Button
      variant="ghost"
      disabled={disabled}
      onClick={() => onClick(config)}
      className={cn(
        'group !flex !flex-col !items-center !text-center !rounded-lg !border !p-[13px] !w-[217px] !h-auto !whitespace-normal !shadow-none',
        disabled
          ? '!border-zinc-200 !bg-zinc-50 !opacity-60 !cursor-not-allowed'
          : '!border-zinc-200 !bg-white hover:!border-indigo-500 hover:!shadow-md hover:!bg-white !cursor-pointer'
      )}
    >
      <img
        src={image}
        alt={title}
        className="w-full aspect-[4/3] rounded-md object-contain mb-2"
      />
      <span
        className={cn(
          'text-[15px] font-semibold mb-[3px] transition-colors',
          disabled
            ? 'text-zinc-400'
            : 'text-zinc-900 group-hover:text-indigo-600'
        )}
      >
        {title}
      </span>
      <span className="text-[11px] text-zinc-500 leading-normal">
        {description}
      </span>
    </Button>
  );
};
